var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Complaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 62,
    viewBox: "0 0 81 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7916 0C51.3933 0 42.9832 8.43739 42.9832 18.8696C42.9832 22.6165 44.0849 26.0939 45.9388 29.0052L43.0907 37.5774C42.4996 39.3835 44.3804 41.0278 46.0732 40.1652L54.1877 36.0948C56.5253 37.1461 59.1047 37.7391 61.7916 37.7391C72.19 37.7391 80.6 29.3017 80.6 18.8696C80.6 8.43739 72.19 0 61.7916 0ZM24.1749 8.08696C16.759 8.08696 10.7403 14.1252 10.7403 21.5652V24.2609C10.7403 31.7009 16.759 37.7391 24.1749 37.7391C31.5907 37.7391 37.6094 31.7009 37.6094 24.2609V21.5652C37.6094 14.1252 31.5907 8.08696 24.1749 8.08696ZM59.3465 8.4913H64.7204L64.2904 21.9696H59.8033L59.3465 8.4913ZM62.0334 24.6652C63.5112 24.6652 64.7204 25.8783 64.7204 27.3609C64.7204 28.8435 63.5112 30.0565 62.0334 30.0565C60.5556 30.0565 59.3465 28.8435 59.3465 27.3609C59.3465 25.8783 60.5556 24.6652 62.0334 24.6652ZM24.1749 43.1304C15.3618 43.1304 4.07676 48.1713 0.825597 53.6704C-1.18959 57.067 0.71812 62 4.02302 62H44.3267C47.6316 62 49.5393 57.067 47.5241 53.6704C44.273 48.1713 32.9879 43.1304 24.1749 43.1304Z",
    fill: "#04A96D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Complaint);
export default __webpack_public_path__ + "static/media/icons8-complaint.4ae50485db7f0859debe72fd6e1fad61.svg";
export { ForwardRef as ReactComponent };